/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:flex;flex:1 0 auto}.main-container[_ngcontent-%COMP%]   .content-container[_ngcontent-%COMP%]{padding:0;display:flex;flex-direction:column}.main-container[_ngcontent-%COMP%]{width:100vw;overflow-x:auto;background:#fff}"];
export { styles as styles };
